import type { ObjectDirective, DirectiveBinding, Directive } from "vue";
import { useSipStore } from "@/store/sip";

type MaybePhone = string | null | undefined;

interface ElWithCleanup extends HTMLElement {
  __callablePhoneCleanup__?: () => void;
}

const callablePhone: Directive = {
  mounted(el: ElWithCleanup, binding: DirectiveBinding<MaybePhone>) {
    const sipStore = useSipStore();

    const clickHandler = (e: MouseEvent) => {
      const phone = binding.value;

      if (!phone || `${phone}`.trim() === "") return;

      sipStore.callPhoneNumber(e, `${phone}`);
    };

    el.addEventListener("click", clickHandler);

    el.__callablePhoneCleanup__ = () => {
      el.removeEventListener("click", clickHandler);
    };
  },

  updated(el, binding) {
    // il clickHandler legge sempre binding.value aggiornato
  },

  unmounted(el: ElWithCleanup) {
    el.__callablePhoneCleanup__?.();
  },
};

export default callablePhone;
